module.exports = __webpack_public_path__ + "static/Omnichannel-Experiences-c35babb6806056a08b9564983ec12b7e.jpg";